/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { TestimonialComponentDisplay } from "cms/components/components/testimonial/display";
import { TestimonialComponentEdit } from "cms/components/components/testimonial/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

const TestimonialComponent = (props) => {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <TestimonialComponentDisplay />,
        editComponent: <TestimonialComponentEdit />,
    };
    return getComponentZoneLayout(zoneProps);
};

TestimonialComponent.displayName = "TestimonialComponent";
export { TestimonialComponent };
